export const BASE_URL =
    process.env["BASE_URL"] || process.env["NODE_ENV"] === "production"
        ? "https://www.atlassian.com"
        : "https://wac.stg.internal.atlassian.com";
export const IDENTITY_BASE_URL = process.env["NEXT_PUBLIC_IDENTITY_BASE_URL"];
export const SAC_URL =
    process.env["NODE_ENV"] === "production"
        ? "https://support.atlassian.com"
        : "https://support.stg.internal.atlassian.com";
export const FASTSHIFT_PORTAL_MARKETING_URL = `${BASE_URL}/migration/fastshift`;

export const AS_A_TEAM_URL =
    process.env["NODE_ENV"] === "production"
        ? "https://as-a-team.atlassian.net"
        : "https://as-a-team-test.atlassian.net";

export const FASTSHIFT_PATH_KEYS = {
    FASTSHIFT: "fastshift",
    SELECTION: "selection",
    RESOURCES_PARTNER_SCOPED: "resources-partner-scoped",
    PLANNING: "planning",
    OVERVIEW: "overview",
    RESOURCES_DOMAIN_SCOPED: "resources-domain-scoped",
    TICKETS: "tickets"
} as const;

export type FASTSHIFT_PATH_KEYS =
    (typeof FASTSHIFT_PATH_KEYS)[keyof typeof FASTSHIFT_PATH_KEYS];

export const FASTSHIFT_AUTH_REDIRECT_URL =
    "/gateway/api/start/fastshift/authredirect";

export const FASTSHIFT_BASE_URL_PROD = "https://fastshift.atlassian.com";
export const FASTSHIFT_BASE_URL_STAGING =
    "https://fastshift.stg.internal.atlassian.com";
// development environment is not fully set up so expect errors if you use this environment
export const FASTSHIFT_BASE_URL_DEV =
    "https://fastshift.dev.internal.atlassian.com";

export const MARATHON_BASE_URL_PROD =
    "https://marathon.us-east-1.prod.atl-paas.net";
export const MARATHON_BASE_URL_STAGING =
    "https://marathon.us-east-1.staging.atl-paas.net";

export const FASTSHIFT_BASE_URL =
    process.env["NODE_ENV"] === "production"
        ? FASTSHIFT_BASE_URL_PROD
        : process.env["NODE_ENV"] === "staging"
        ? FASTSHIFT_BASE_URL_STAGING
        : FASTSHIFT_BASE_URL_DEV;

export const FASTSHIFT_DOMAINS = [
    "fastshift.atlassian.com",
    "fastshift.stg.internal.atlassian.com",
    "fastshift.dev.internal.atlassian.com",
    "fastshift-portal.ddev.frontend.public.atl-paas.net",
    "fastshift-portal.stg-east.frontend.public.atl-paas.net",
    "fastshift-portal.prod-east.frontend.public.atl-paas.net"
];

export const FASTSHIFT_PATHS: {
    [key in FASTSHIFT_PATH_KEYS]: string;
} = {
    [FASTSHIFT_PATH_KEYS.FASTSHIFT]: "fastshift",
    [FASTSHIFT_PATH_KEYS.SELECTION]: "fastshift/selection",
    [FASTSHIFT_PATH_KEYS.RESOURCES_PARTNER_SCOPED]: "fastshift/resources",
    [FASTSHIFT_PATH_KEYS.PLANNING]: "fastshift/:domainId/planning",
    [FASTSHIFT_PATH_KEYS.OVERVIEW]: "fastshift/:domainId/overview",
    [FASTSHIFT_PATH_KEYS.RESOURCES_DOMAIN_SCOPED]:
        "fastshift/:domainId/resources",
    [FASTSHIFT_PATH_KEYS.TICKETS]: "fastshift/:domainId/tickets"
} as const;

export const FASTSHIFT_HOME_PATH: string =
    FASTSHIFT_PATHS[FASTSHIFT_PATH_KEYS.FASTSHIFT];

export type FastshiftPath = typeof FASTSHIFT_PATHS;
export type FastshiftPathValue = FastshiftPath[FASTSHIFT_PATH_KEYS];

export const FASTSHIFT_EAP_HOME_PATH = "fastshift/dashboard";
